export default __webpack_public_path__ + "static/media/quiz.491a97a1.jpg";